import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '../configuration/configuration.service';

@Injectable({
  providedIn: 'root',
})
export class GabaritService {
  protected readonly configService = inject(ConfigurationService);
  constructor() {}

  public isWebMobile(): boolean {
    return (
      this.configService.getValueOrDefault(configuration.ConfigMeta.OEL_IS_WEBMOBILE, 'false') ===
        'true' || globalThis.matchMedia('(max-width: 639.98px)').matches
    );
  }

  public isAppMobile(): boolean {
    return (
      this.configService.getValueOrDefault(configuration.ConfigMeta.OEL_IS_APP, 'false') === 'true'
    );
  }
}
